exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".donutchart-track {\n  fill: transparent;\n  stroke: #DAE2E5;\n  stroke-width: 26; }\n\n.donutchart-indicator {\n  fill: transparent;\n  stroke: #ad974f;\n  stroke-width: 26;\n  stroke-dasharray: 0 10000;\n  transition: stroke-dasharray .3s ease; }\n\n.donutchart {\n  margin: 0 auto;\n  border-radius: 50%;\n  display: block;\n  margin-right: -25px; }\n\n.donutchart-text {\n  font-family: 'Roboto';\n  fill: #607580; }\n\n.donutchart-text-val {\n  font-size: 22px; }\n\n.donutchart-text-percent {\n  font-size: 14px; }\n\n.donutchart-text-label {\n  font-size: 9px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Charts/Donut.scss
// module id = 914
// module chunks = 0